// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Rr31","textarea":"styles_textarea__WIWjK"};